import React from 'react';
import Field from '../../shared/ui/Field';
import DropdownSelectControl from '../../shared/ui/DropdownSelectControl';
import { useFieldController } from '../../../../helpers/formManager';
import {
  defaultIntervalMode,
  intervalModes,
} from '../../shared/configs/selectionData/intervalModes';
import styles from './index.module.scss';

const options = [...intervalModes.entries()].map(([key, content]) => ({
  key,
  value: key,
  content,
}));

const SelectIntervalAcceptanceType = ({ name, className }) => {
  const {
    field: { value, onChange },
  } = useFieldController({
    name,
    rules: { required: 'Выберите тип интервала' },
    defaultValue: defaultIntervalMode,
  });

  return (
    <Field.Memoized
      type={Field.types.dropdownSelect}
      value={value}
      onChange={onChange}
      options={options}
      renderControl={getRenderControl(value)}
      rootCN={className}
    />
  );
};

export default SelectIntervalAcceptanceType;

function getRenderControl(value) {
  return (props) => {
    const { visible, loading, disabled, className, ...rest } = props;

    return (
      <DropdownSelectControl
        {...rest}
        visible={visible}
        loading={loading}
        disabled={disabled}
        className={styles.btn}
      >
        {intervalModes.get(value) ?? 'Выбрать из списка'}
      </DropdownSelectControl>
    );
  };
}
